const tabs = {
    events: { label: 'Eventos', slug: 'events' },
    touristicPlaces: { label: 'Pontos turísticos', slug: 'touristicPlaces' },
    establishment: { label: 'Estabelecimentos', slug: 'establishment' },
    collect: { label: 'Pontos de coleta', slug: 'collect' },
}

export default tabs;